export const linkedinConstants = {
    LINKEDIN_TARGETS_REQUEST: 'LINKEDIN_TARGETS_REQUEST',
    LINKEDIN_TARGETS_SUCCESS: 'LINKEDIN_TARGETS_SUCCESS',
    LINKEDIN_TARGETS_ERROR: 'LINKEDIN_TARGETS_ERROR',
    LINKEDIN_TARGETS_RESET: 'LINKEDIN_TARGETS_RESET',
};
